export default __webpack_public_path__ + "static/media/button_normal.2547d969.png";